module.exports = __webpack_public_path__ + "img/sari-event.c970af4.webp";